type CloseObjectSidebarRemixPicker = (contentId: string) => void;

const listeners = new Set<CloseObjectSidebarRemixPicker>();

export const subscribeToObjectSidebarRemixPickerClose = (
	listener: CloseObjectSidebarRemixPicker,
): (() => void) => {
	listeners.add(listener);
	return () => listeners.delete(listener);
};

export const closeObjectSidebarRemixPicker = (contentId: string): void => {
	listeners.forEach((listener) => listener(contentId));
};

export const clearListenersForTesting = (): void => {
	listeners.clear();
};
